// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * How a `Notification`'s stored message selector is matched against an
 * incoming LN2 message.
 *
 * CATEGORY (0) — fire on ANY message whose `message_content` matches, ignoring
 *                `message_value`. This is the ZERO value on purpose: the
 *                delivery engine has never read `message_value`, so a row
 *                written before this field existed decodes to exactly the
 *                behaviour it already had.
 * EXACT    (1) — fire only when BOTH `message_content` and `message_value`
 *                match. New capability, not a restoration.
 * ANY      (2) — fire on any decodable message for the notification's banks,
 *                ignoring both selectors.
 *
 * Never test this field against 0 to mean "unset" — CATEGORY is a real,
 * meaningful member. Values are APPEND-ONLY.
 */
export enum MessageMatchMode {
  CATEGORY = 0,
  EXACT = 1,
  ANY = 2,
}
